module.exports = __webpack_public_path__ + "img/core-top.79250b45.png";